import styled, { css } from "styled-components";

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-bottom: 46px;
`;

interface IImgCard {
  isprogress?: string;
  haserror?: string;
}

export const ImgCard = styled.div<IImgCard>`
  position: relative;
  width: 100%;
  height: 64px;
  min-height: 64px;
  max-height: 64px;
  display: flex;
  flex-direction: row;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  margin-top: 6px;
  
  .image {
    position: relative;
    width: 96px;
    height: 64px;
    
    img {
      width: 96px;
      min-width: 96px;
      max-width: 96px;
      height: 64px;
      min-height: 64px;
      max-height: 64px;
      object-fit: contain;
      z-index: 1;
    }
    
    .progressBar {
      position: absolute;
      bottom: 0;
      left: 0;
      padding-left: 10px;
      margin-bottom: 0;
      z-index: 2;
    }
  
    ${({ isprogress }) => isprogress === 'true' && css`
      .progressMask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #000000;
        opacity: 0.5;
        z-index: 3;
      }
    `}
  
    ${({ haserror }) => haserror === 'true' && css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 96px;
      min-height: 64px;
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.danger.dangerContainer}, ${theme.colors.surface.surface})`};
    `}
  }

  .imgContent {
    width: 100%;
    height: 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-left: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    padding: 6px 12px;

    .imgTextContent {
      width: 100%;
      display: flex;
      flex-direction: column;
      white-space: normal;
      overflow: hidden;

      .textName {
        font-size: 12px;
        font-weight: 600;
        line-height: 16px; 
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }

      .textSize {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px; 
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        margin-top: 4px;
      }

      .imgTextCreatorContent {
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin-top: 4px;

        .textCreator {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px; 
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
          margin-left: 6px;
        }
      }

      ${({ haserror }) => haserror === 'true' && css`
        .textName {
          color: ${({ theme }) => theme.colors.danger.danger};
        }
        .textSize {
          color: ${({ theme }) => theme.colors.danger.danger};
        }
      `}
    }

    .buttonCancelOrDelete {
      padding: 0;
      width: 24px !important;
      height: 24px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 6px;
  
      .iconCancelOrDelete {
        color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant} !important;
      }
    }  
    
    .btnOpenActionAttachment {
      padding: 0;
      width: 24px !important;
      height: 24px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;

      .iconOpenActionAttachment {
        color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant} !important;
      }

      :focus {
        border: none !important;
      }
    }
  }

  :first-child {
    margin-top: 0;
  }

 &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfacePressed}, ${theme.colors.surface.surface})`} !important;
  }
`;
